export default __webpack_public_path__ + "static/media/keno_win.707d2433.mp3";